module.exports = __webpack_public_path__ + "static/tooltip-bold-dont-cbe5d0e368ef1fa9a0288373179853cc.png";